// Stub file for StructDocs
// This file was removed but is needed for backward compatibility

export interface FieldDoc {
  name: string;
  jsonName: string;
  type: string;
  frontendType: string;
  comment: string;
  isRepeated: boolean;
  isOptional: boolean;
  isHidden: boolean;
}

export interface StructDoc {
  typeName: string;
  displayName: string;
  category: string;
  comment: string;
  baseStruct?: string;
  fields: FieldDoc[];
}

export const structDocumentationData: StructDoc[] = [];

export const getEntityFieldsWithBase = (struct: StructDoc | undefined): FieldDoc[] => {
  if (!struct) return [];

  const fields = [...struct.fields];

  // If there's a base struct, recursively get its fields
  if (struct.baseStruct) {
    const baseStruct = structDocumentationData.find(s => s.typeName === struct.baseStruct);
    if (baseStruct) {
      const baseFields = getEntityFieldsWithBase(baseStruct);
      fields.push(...baseFields);
    }
  }

  return fields;
};
